<template>
  <woot-modal
    :show.sync="show"
    :on-close="onCancel"
    portal-to-body
    :content-class="modalContentClass"
  >
    <div class="new-conversation-modal__body flex min-h-0 flex-1 flex-col overflow-y-auto">
      <woot-modal-header
        :header-title="$t('NEW_CONVERSATION.TITLE')"
        :header-content="$t('NEW_CONVERSATION.DESC')"
      />
      <conversation-form
        :contact="contact"
        :on-submit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      />
    </div>
  </woot-modal>
</template>

<script>
import ConversationForm from './ConversationForm';

export default {
  components: {
    ConversationForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
    openOverContactPanel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalContentClass() {
      return [
        'new-conversation-modal',
        this.openOverContactPanel
          ? 'new-conversation-modal--over-contact-panel'
          : '',
      ]
        .filter(Boolean)
        .join(' ');
    },
  },
  watch: {
    async 'contact.id'(id) {
      if (id) {
        const inboxData = await this.$store.dispatch('contacts/fetchContactableInbox', id);
        this.$set(this.contact, 'contactableInboxes', inboxData.contactableInboxes);
      }
    },
    async show(isVisible) {
      if (isVisible && this.contact?.id) {
        const inboxData = await this.$store.dispatch('contacts/fetchContactableInbox', this.contact.id);
        this.$set(this.contact, 'contactableInboxes', inboxData.contactableInboxes);
      }
    },
  },
  async mounted() {
    const id = this.contact?.id;
    if (id) {
      const inboxData = await this.$store.dispatch('contacts/fetchContactableInbox', id);
      this.$set(this.contact, 'contactableInboxes', inboxData.contactableInboxes);
    }
  },  

  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      const data = await this.$store.dispatch(
        'createConversationFromContact',
        contactItem
      );
      return data;
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.modal-container.new-conversation-modal) {
  @apply rounded-xl overflow-hidden flex flex-col max-h-full;

  > .modal--close {
    right: 1rem;
  }
}

:deep(.modal-container.new-conversation-modal--over-contact-panel) {
  position: fixed;
  top: calc(10vh + (100vh - 10vh - 14vh) / 2);
  left: 50%;
  transform: translate(-50%, -50%);
  width: 35%;
  max-width: 37.5rem;
  max-height: calc(100vh - 10vh - 14vh);
}

/*
 * Keep the contact panel visible behind this dialog (same band as `.special-panel-styles`).
 */
:deep(
    .modal-mask.modal-mask--body-portal:has(
        .new-conversation-modal--over-contact-panel
      )
  ) {
  align-items: center;
  justify-content: center;
}
</style>
